var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0271 0.829122C11.5877 0.351351 12.4123 0.351351 12.9729 0.829121L15.3042 2.81581C15.5444 3.02054 15.8431 3.14427 16.1578 3.16938L19.211 3.41303C19.9453 3.47163 20.5284 4.05469 20.587 4.78896L20.8306 7.84221C20.8557 8.15686 20.9795 8.45557 21.1842 8.69581L23.1709 11.0271C23.6486 11.5877 23.6486 12.4123 23.1709 12.9729L21.1842 15.3042C20.9795 15.5444 20.8557 15.8431 20.8306 16.1578L20.587 19.211C20.5284 19.9453 19.9453 20.5284 19.211 20.587L16.1578 20.8306C15.8431 20.8557 15.5444 20.9795 15.3042 21.1842L12.9729 23.1709C12.4123 23.6486 11.5877 23.6486 11.0271 23.1709L8.69581 21.1842C8.45557 20.9795 8.15686 20.8557 7.84221 20.8306L4.78896 20.587C4.0547 20.5284 3.47163 19.9453 3.41303 19.211L3.16938 16.1578C3.14427 15.8431 3.02054 15.5444 2.81581 15.3042L0.829122 12.9729C0.351351 12.4123 0.351351 11.5877 0.829121 11.0271L2.81581 8.69581C3.02054 8.45557 3.14427 8.15686 3.16938 7.84221L3.41303 4.78896C3.47163 4.0547 4.05469 3.47163 4.78896 3.41303L7.84221 3.16938C8.15686 3.14427 8.45557 3.02054 8.69581 2.81581L11.0271 0.829122Z",
    fill: "#7E84FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6057 9.99609L11.0057 13.5961L9.53906 11.9961",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified);
export default __webpack_public_path__ + "static/media/verified.25d155cfe490782592f3be570ee1aebe.svg";
export { ForwardRef as ReactComponent };